import React, { useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Social from "../components/Social";
import About from "../components/About";
import Audiences from "../components/Audiences";
import BookCTA from "../components/BookCTA";
import Features from "../components/Features";
import OurAccommodation from "../components/OurAccommodation";
import OurTownhouses from "../components/OurTownhouses";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import FloatingActions from "../components/FloatingActions";

export default function Home() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen bg-white">
      <Header transparent />
      <Hero />
      <Social />
      <About />
      <Audiences />
      <OurAccommodation />
      <BookCTA />
      <Features />
      <OurTownhouses />
      <Contact />
      <Footer />
      <FloatingActions />
    </div>
  );
}
